<div class="flex flex-col gap-6">
  <div class="flex justify-between items-center">
    <h2 class="text-3xl font-semibold text-gray-12 flex-1 text-center">Toutes les photos</h2>
    <div class="flex gap-3 items-center">
      @if (photos().length > 0) {
        <button mat-stroked-button (click)="manageClicked.emit()">Gérer les photos</button>
      }
      <button mat-mini-fab color="primary" (click)="addClicked.emit()" aria-label="Ajouter une photo">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>

  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-6">
    @for (photo of photos(); track photo.file || $index; let i = $index) {
      <div class="flex flex-col gap-3 group" [class.col-span-2]="i === 0" [class.row-span-2]="i === 0">
        <div
          class="rounded-2xl overflow-hidden bg-gray-2 shadow-sm relative transition-all duration-300 group-hover:shadow-md cursor-pointer focus:outline-none focus:ring-4 focus:ring-brand-9"
          [class.flex-1]="i === 0"
          [class.aspect-[4/3]]="i !== 0"
          (click)="manageClicked.emit()"
          (keydown.enter)="manageClicked.emit()"
          (keydown.space)="manageClicked.emit(); $event.preventDefault()"
          tabindex="0"
          role="button"
          aria-label="Gérer la photo"
        >
          <img
            [src]="photo.url"
            alt="Property photo"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />

          @if (i === 0) {
            <div class="absolute top-3 left-3 z-10">
              <div
                class="bg-brand-9 text-white text-[10px] font-bold uppercase py-1 px-2.5 rounded-full shadow-lg flex items-center gap-1.5 backdrop-blur-md"
              >
                <mat-icon class="!w-3 !h-3 !text-[12px] leading-none">star</mat-icon>
                <span>Couverture</span>
              </div>
            </div>
          }

          @if (
            photo.isHiddenBeforeMandate ||
            (photo.characteristicRef && photo.characteristicRef.section !== 'interior')
          ) {
            <div class="absolute top-3 right-3 z-10">
              <div
                class="bg-amber-9 text-amber-contrast text-[10px] font-bold py-1 px-2.5 rounded-full shadow-lg flex items-center gap-1 backdrop-blur-md"
                matTooltip="Photo protégée : visible par l'agent uniquement après la première visite"
              >
                <mat-icon class="!w-3 !h-3 !text-[12px] leading-none">lock</mat-icon>
                <span>Visite requise</span>
              </div>
            </div>
          }

          <div class="absolute bottom-4 right-4 z-10">
            <div
              class="bg-black/50 text-white text-[10px] font-bold px-3 py-1.5 rounded-full backdrop-blur-md border border-white/10 shadow-sm"
            >
              {{ i + 1 }} / {{ photos().length }}
            </div>
          </div>
        </div>

        <div class="px-1">
          <h3 class="text-base font-semibold text-gray-12 m-0 leading-tight truncate">
            {{
              photo.characteristicRef | etxeEnumDisplay: 'characteristicCategory' : propertyCharacteristics()
            }}
          </h3>
        </div>
      </div>
    } @empty {
      <div
        class="col-span-full py-20 bg-gray-2 rounded-2xl border-2 border-dashed border-gray-4 flex flex-col items-center justify-center text-gray-10"
      >
        <mat-icon class="w-16 h-16 text-[64px] mb-4 opacity-20">image</mat-icon>
        <p class="text-lg font-medium opacity-60">Aucune photo pour le moment</p>
        <button mat-button color="primary" class="mt-4" (click)="addClicked.emit()">
          <mat-icon>add</mat-icon>
          Ajouter ma première photo
        </button>
      </div>
    }
  </div>
</div>
